import { createContext, useContext } from 'react';
import type { IAsset, ProviderRegistry, ZapworksProvider } from '../providers';
import type { ILabel } from '@zappar/zw-api-client';

interface AssetActionsContextValue {
  zapworksProvider: ZapworksProvider | undefined;
  workspaceId: string;
  /** Provider registry containing external providers */
  registry?: ProviderRegistry;
  hasPersonalAssets?: boolean;
  onUpdateLabels?: (asset: IAsset, labels: ILabel[]) => Promise<IAsset | void>;
  onCreateLabel?: (name: string) => Promise<void>;
  onEditLabel?: (uid: string, newName: string) => Promise<void>;
  onDeleteLabel?: (uid: string) => Promise<void>;
  onViewLabelAnalytics?: (labelId: string) => void;
  onAddToProject?: (asset: IAsset) => void;
  onAddToWorkspaceAssets?: (assets: IAsset[]) => Promise<void>;
  onMoveAllFilesToWorkspace?: (workspaceId: string) => Promise<void>;
  onDownloadCSV?: (error?: unknown) => void;
}

const AssetActionsContext = createContext<AssetActionsContextValue>({
  zapworksProvider: undefined,
  workspaceId: '',
  hasPersonalAssets: true,
});

export const useAssetActions = () => useContext(AssetActionsContext);

export const AssetActionsProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: AssetActionsContextValue;
}) => <AssetActionsContext.Provider value={value}>{children}</AssetActionsContext.Provider>;
